module.exports = __webpack_public_path__ + "static/media/avatar.b29abfb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/avatar.jpg
// module id = 178
// module chunks = 0